import devopsHeader from '../../components/dashboard/paywall/sales-activated-trial/page/images/devops-header.png';
import devopsSection1 from '../../components/dashboard/paywall/sales-activated-trial/page/images/devops-section1.png';
import devopsSection2 from '../../components/dashboard/paywall/sales-activated-trial/page/images/devops-section2.png';
import devopsSection3 from '../../components/dashboard/paywall/sales-activated-trial/page/images/devops-section3.png';
import type { PageblockData } from '../pageblockTypes';

export const PAGEBLOCK_DATA_DEVOPS_CENTER: PageblockData = {
  headerData: {
    headerText: 'Easily compare & deploy Sweep elements',
    subHeaderText:
      'Take full control of your Sweep configurations by seamlessly managing deployments across Sandbox, Production, and other Salesforce  environments.',
    imgSrc: devopsHeader,
    imgAlt: 'Devops header',
    name: 'Compare & Deploy',
  },
  pageTitle: 'See what’s been deployed to any of your Salesforce environments',
  section1: {
    imgSrc: devopsSection1,
    imgAlt: 'Devops section img',
    title: 'Track Sweep elements across environments',
    content:
      'Gain a clear, side-by-side view of all deployed Sweep elements—including automations, lead routing rules, assignment logic, and more. Instantly identify differences and ensure consistency between environments.',
  },
  section2: {
    imgSrc: devopsSection2,
    imgAlt: 'Devops section 2 img',
    title: 'Deploy with confidence',
    content:
      'Compare versions of Sweep elements and identify changes before deploying. Whether you need to update a single rule, a set of automations, or a full process, you can deploy with precision and ease.',
  },
  section3: {
    imgSrc: devopsSection3,
    imgAlt: 'Devops section 3 img',
    title: 'Simplify Sweep deployment & version management',
    content:
      'Ensure every Sweep configuration is properly deployed across environments. Streamline updates, prevent misconfigurations, and maintain a smooth, reliable deployment process with built-in comparison and deployment tools.',
  },
};
